import React from 'react';
import { wrapReactionHook } from "../../hooks";
export var NameProgressStatus = wrapReactionHook(function (props) {
  var children = props.children;
  return /*#__PURE__*/React.createElement("div", props, "NameProgressStatus", children);
});